import { useState } from "react";
import { PageTemplate } from "@/views/PageTemplate";
import { BrickIcon } from "@/components/icons";
import usdcTokenImage from "@/assets/tokens/usdc.svg?url";
import iusdTokenImage from "@/assets/tokens/icon_i-onlight.svg?url";
import mintIusdIcon from "@/assets/icons/mint-iusd.svg?url";

export function MintPage() {
  const [inputAmount, setInputAmount] = useState("1,000.00");
  const [outputAmount] = useState("1,000.00");

  const handleMint = () => {
    console.log("Mint requested:", { inputAmount, outputAmount });
  };

  return (
    <PageTemplate title='Mint' subtitle='Exchange one token for another.' icon={<BrickIcon active={true} className='h-[16px]' />}>
      <div className='bg-(--light-gray) rounded-2xl p-6 mb-[48px]'>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
          {/* Input Amount Section */}
          <div>
            <p className='text-(--gray-3) mb-2 text-sm text-left font-medium'>Amount to convert...</p>
            <div className='flex items-center bg-white rounded-lg p-4 border border-gray-200'>
              <input
                type='text'
                value={inputAmount}
                onChange={(e) => setInputAmount(e.target.value)}
                className='flex-1 text-xl font-medium outline-none'
                placeholder='0.00'
              />
              <div className='flex items-center gap-2 ml-2'>
                <img src={usdcTokenImage} alt='USDC' className='w-6 h-6 rounded-full' />
                <span className='font-medium'>USDC</span>
                <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path d='M4 6L8 10L12 6' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
                </svg>
              </div>
            </div>
            <p className='text-(--gray-3) text-left text-sm mt-2'>Available in your wallet: 15,384.59 USDC</p>
          </div>

          {/* Output Amount Section */}
          <div>
            <p className='text-(--gray-3) mb-2 text-sm text-left font-medium'>You will mint and recieve...</p>
            <div className='flex items-center bg-white rounded-lg p-4 border border-gray-200'>
              <div className='flex items-center gap-2 mr-2'>
                <img src={iusdTokenImage} alt='iUSD' className='w-6 h-6 rounded-full' />
                <span className='font-medium'>iUSD</span>
                <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path d='M4 6L8 10L12 6' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
                </svg>
              </div>
              <input type='text' value={outputAmount} readOnly className='flex-1 text-xl font-medium outline-none text-right' placeholder='0.00' />
            </div>
            <p className='text-(--gray-3) text-left text-sm mt-2'>Current balance: 0.00 iUSD</p>
          </div>
        </div>
      </div>

      {/* Transaction Review */}
      <div className='mb-6'>
        <h3 className='font-medium mb-3 text-left text-sm'>Transaction Review</h3>
        <ul className='space-y-2'>
          <li className='flex items-start'>
            <svg className='w-5 h-5 text-blue-500 mr-2 flex-shrink-0 mt-0.5' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path d='M5 12L10 17L19 8' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            </svg>
            <span className='text-sm'>You are using 1,000 USDC tokens to mint 1,000 iUSD.</span>
          </li>
          <li className='flex items-start'>
            <svg className='w-5 h-5 text-blue-500 mr-2 flex-shrink-0 mt-0.5' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path d='M5 12L10 17L19 8' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            </svg>
            <span className='text-sm'>As a stablecoin, iUSD is always redeemable 1:1 for USDC.</span>
          </li>
          <li className='flex items-start'>
            <svg className='w-5 h-5 text-blue-500 mr-2 flex-shrink-0 mt-0.5' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path d='M5 12L10 17L19 8' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            </svg>
            <span className='text-sm'>
              Based on the current{" "}
              <a href='#' className='text-blue-600 underline'>
                slippage settings
              </a>{" "}
              of 0.1%, the minimum you will receive is 998.24 iUSD tokens.
            </span>
          </li>
        </ul>
      </div>

      {/* Mint Button */}
      <div>
        <button
          onClick={handleMint}
          className='flex items-center justify-center gap-2 bg-blue-500 text-white py-3 px-6 rounded-lg font-medium hover:bg-blue-600 transition-colors w-auto'
        >
          Mint iUSD
          <img src={mintIusdIcon} alt='Mint' className='w-4 h-4' />
        </button>
      </div>
    </PageTemplate>
  );
}
